	import React, { useState, useEffect } from 'react';
	import { useNavigate } from 'react-router-dom';
	import axios from 'axios';
	import './Cart.css';

	function Cart() {
		const [cart, setCart] = useState([]);
		const [selectedItems, setSelectedItems] = useState([]);
		const [isLoggedIn, setIsLoggedIn] = useState(false);
		const navigate = useNavigate();

		useEffect(() => {
			checkLoginAndLoadCart();
		}, []);

		const checkLoginAndLoadCart = async () => {
			const token = localStorage.getItem('access_token');
			
			console.log('🛒 장바구니 로딩 시작, 토큰:', !!token);  // 🔥 로그 추가
			
			if (token) {
				setIsLoggedIn(true);
				console.log('🛒 로그인 상태 → DB 조회');  // 🔥 로그 추가
				await syncAndLoadCart();
			} else {
				setIsLoggedIn(false);
				console.log('🛒 비로그인 상태 → localStorage 조회');  // 🔥 로그 추가
				loadLocalCart();
			}
		};


		// 🔥 로그인 시: localStorage → DB 동기화 후 DB 데이터 로드
		const syncAndLoadCart = async () => {
			try {
				console.log('🔵 syncAndLoadCart 시작');  // 🔥 로그 추가
				
				const localCart = JSON.parse(localStorage.getItem('cart') || '[]');
				console.log('📦 localStorage 장바구니:', localCart);  // 🔥 로그 추가
				
				if (localCart.length > 0) {
					console.log('🔄 DB 동기화 시작');  // 🔥 로그 추가
					await axios.post(
						'https://api.weartoday.kr/api/products/cart/sync/',
						{ cart: localCart },
						{
							headers: {
								'Authorization': `Bearer ${localStorage.getItem('access_token')}`
							}
						}
					);
					
					localStorage.removeItem('cart');
				}
				
				console.log('📡 DB 장바구니 조회 시작');  // 🔥 로그 추가
				
				const response = await axios.get(
					'https://api.weartoday.kr/api/products/cart/',
					{
						headers: {
							'Authorization': `Bearer ${localStorage.getItem('access_token')}`
						}
					}
				);
				
				console.log('✅ DB 응답:', response.data);  // 🔥 로그 추가
				
				const cartData = response.data.results || response.data || [];
				
				console.log('🛒 최종 장바구니 데이터:', cartData);  // 🔥 로그 추가
				console.log('🛒 데이터 개수:', cartData.length);  // 🔥 로그 추가
				
				setCart(cartData);
				setSelectedItems(cartData.map(item => item.id));
				
			} catch (error) {
				console.error('❌ 장바구니 로드 실패:', error);
				setCart([]);
				loadLocalCart();
			}
		};

		// 🔥 비로그인 시: localStorage 로드
		const loadLocalCart = () => {
			const savedCart = localStorage.getItem('cart');
			if (savedCart) {
				const parsedCart = JSON.parse(savedCart);
				setCart(parsedCart);
				setSelectedItems(parsedCart.map((item, idx) => idx));
			}
		};

		const getImageUrl = (item) => {
			const productData = item.product || item;
			
			// main_images 배열에서 동영상 제외하고 첫 번째 이미지
			if (productData.main_images && Array.isArray(productData.main_images)) {
				const imageUrl = productData.main_images.find(img => 
					img && !img.toLowerCase().endsWith('.mp4')
				);
				if (imageUrl) {
					if (imageUrl.startsWith('/media')) {
						return `https://api.weartoday.kr${imageUrl}`;
					}
					return imageUrl;
				}
			}
			
			// image 필드 (단일 이미지)
			if (productData.image && !productData.image.toLowerCase().endsWith('.mp4')) {
				if (productData.image.startsWith('/media')) {
					return `https://api.weartoday.kr${productData.image}`;
				}
				return productData.image;
			}
			
			// images 배열 처리
			if (productData.images && Array.isArray(productData.images)) {
				const mainImage = productData.images.find(img => 
					img.is_main && img.image && !img.image.toLowerCase().endsWith('.mp4')
				);
				if (mainImage) {
					if (mainImage.image.startsWith('/media')) {
						return `https://api.weartoday.kr${mainImage.image}`;
					}
					return mainImage.image;
				}
				
				const firstImage = productData.images.find(img => 
					img.image && !img.image.toLowerCase().endsWith('.mp4')
				);
				if (firstImage) {
					if (firstImage.image.startsWith('/media')) {
						return `https://api.weartoday.kr${firstImage.image}`;
					}
					return firstImage.image;
				}
			}
			
			return 'https://via.placeholder.com/100?text=No+Image';
		};

		const toggleSelectAll = () => {
			if (selectedItems.length === cart.length) {
				setSelectedItems([]);
			} else {
				setSelectedItems(cart.map((item, idx) => isLoggedIn ? item.id : idx));
			}
		};

		const toggleSelectItem = (itemId) => {
			if (selectedItems.includes(itemId)) {
				setSelectedItems(selectedItems.filter(id => id !== itemId));
			} else {
				setSelectedItems([...selectedItems, itemId]);
			}
		};

		const updateQuantity = async (itemId, newQuantity) => {
			if (newQuantity < 1) return;
			
			if (isLoggedIn) {
				// DB 업데이트
				try {
					await axios.patch(
						`https://api.weartoday.kr/api/products/cart/${itemId}/`,
						{ quantity: newQuantity },
						{
							headers: {
								'Authorization': `Bearer ${localStorage.getItem('access_token')}`
							}
						}
					);
					
					const updatedCart = cart.map(item =>
						item.id === itemId ? { ...item, quantity: newQuantity } : item
					);
					setCart(updatedCart);
					
				} catch (error) {
					console.error('수량 변경 실패:', error);
					alert('수량 변경에 실패했습니다.');
				}
			} else {
				// localStorage 업데이트
				const updatedCart = cart.map((item, idx) =>
					idx === itemId ? { ...item, quantity: newQuantity } : item
				);
				setCart(updatedCart);
				localStorage.setItem('cart', JSON.stringify(updatedCart));
			}
		};

		const removeItem = async (itemId) => {
			if (!window.confirm('이 상품을 장바구니에서 삭제하시겠습니까?')) return;
			
			if (isLoggedIn) {
				// DB 삭제
				try {
					await axios.delete(
						`https://api.weartoday.kr/api/products/cart/${itemId}/`,
						{
							headers: {
								'Authorization': `Bearer ${localStorage.getItem('access_token')}`
							}
						}
					);
					
					const updatedCart = cart.filter(item => item.id !== itemId);
					setCart(updatedCart);
					setSelectedItems(selectedItems.filter(id => id !== itemId));
					
				} catch (error) {
					console.error('삭제 실패:', error);
					alert('삭제에 실패했습니다.');
				}
			} else {
				// localStorage 삭제
				const updatedCart = cart.filter((_, idx) => idx !== itemId);
				setCart(updatedCart);
				localStorage.setItem('cart', JSON.stringify(updatedCart));
				setSelectedItems(selectedItems.filter(id => id !== itemId));
			}
		};

		const removeSelectedItems = async () => {
			if (selectedItems.length === 0) {
				alert('삭제할 상품을 선택해주세요.');
				return;
			}
			
			if (!window.confirm(`선택한 ${selectedItems.length}개 상품을 삭제하시겠습니까?`)) return;
			
			if (isLoggedIn) {
				// DB 삭제
				try {
					await Promise.all(
						selectedItems.map(id =>
							axios.delete(
								`https://api.weartoday.kr/api/products/cart/${id}/`,
								{
									headers: {
										'Authorization': `Bearer ${localStorage.getItem('access_token')}`
									}
								}
							)
						)
					);
					
					const updatedCart = cart.filter(item => !selectedItems.includes(item.id));
					setCart(updatedCart);
					setSelectedItems([]);
					
				} catch (error) {
					console.error('삭제 실패:', error);
					alert('삭제에 실패했습니다.');
				}
			} else {
				// localStorage 삭제
				const updatedCart = cart.filter((_, idx) => !selectedItems.includes(idx));
				setCart(updatedCart);
				localStorage.setItem('cart', JSON.stringify(updatedCart));
				setSelectedItems([]);
			}
		};

		const getSelectedTotalPrice = () => {
			return cart
				.filter((item, idx) => selectedItems.includes(isLoggedIn ? item.id : idx))
				.reduce((total, item) => total + (item.price * item.quantity), 0);
		};

		const handleCheckout = () => {
			if (selectedItems.length === 0) {
				alert('주문할 상품을 선택해주세요.');
				return;
			}
			
			if (!isLoggedIn) {
				alert('로그인이 필요합니다.');
				navigate('/login');
				return;
			}
			
			const selectedProducts = cart.filter((item, idx) =>
				selectedItems.includes(isLoggedIn ? item.id : idx)
			);
			localStorage.setItem('checkoutItems', JSON.stringify(selectedProducts));
			navigate('/checkout');
		};

		if (cart.length === 0) {
			return (
				<div className="cart-page">
					<h1>장바구니</h1>
					<div className="empty-cart">
						<p>장바구니가 비어있습니다.</p>
						<button onClick={() => navigate('/')}>쇼핑 계속하기</button>
					</div>
				</div>
			);
		}

		return (
			<div className="cart-page">
				<h1>장바구니</h1>
				
				<div className="cart-header">
					<label className="select-all-label">
						<input 
							type="checkbox"
							checked={selectedItems.length === cart.length}
							onChange={toggleSelectAll}
						/>
						<span>전체 선택 ({selectedItems.length}/{cart.length})</span>
					</label>
					
					<button 
						className="btn-delete-selected"
						onClick={removeSelectedItems}
					>
						선택 삭제
					</button>
				</div>
				
				<div className="cart-items">
					{cart.map((item, idx) => {
						const itemId = isLoggedIn ? item.id : idx;
						const productData = item.product || item;
						
						return (
							<div key={itemId} className="cart-item">
								<div className="image-wrapper">
									<input 
										type="checkbox"
										className="item-checkbox"
										checked={selectedItems.includes(itemId)}
										onChange={() => toggleSelectItem(itemId)}
									/>
									<img 
										src={getImageUrl(item)}
										alt={productData.name}
										className="item-image"
										onClick={() => navigate(`/product/${productData.id}`)}
										onError={(e) => {
											e.target.src = 'https://via.placeholder.com/100?text=No+Image';
										}}
									/>
								</div>
								
								<div className="item-details">
									<h3 onClick={() => navigate(`/product/${productData.id}`)}>
										{productData.name}
									</h3>
									
									{item.option_name && (
										<p className="item-option">옵션: {item.option_name}</p>
									)}
									{item.size && (
										<p className="item-option">사이즈: {item.size}</p>
									)}
									
									<p className="item-price">
										₩{Number(item.price).toLocaleString()}
									</p>
								</div>
								
								<div className="item-actions">
									<div className="quantity-controls">
										<button 
											onClick={() => updateQuantity(itemId, item.quantity - 1)}
											disabled={item.quantity <= 1}
										>
											-
										</button>
										<input 
											type="number"
											value={item.quantity}
											onChange={(e) => {
												const val = parseInt(e.target.value) || 1;
												updateQuantity(itemId, val);
											}}
											min="1"
										/>
										<button 
											onClick={() => updateQuantity(itemId, item.quantity + 1)}
										>
											+
										</button>
									</div>
									
									<p className="item-total">
										₩{(Number(item.price) * item.quantity).toLocaleString()}
									</p>
									
									<button 
										className="remove-btn"
										onClick={() => removeItem(itemId)}
									>
										삭제
									</button>
								</div>
							</div>
						);
					})}
				</div>
				
				<div className="cart-summary">
					<div className="summary-row">
						<span>선택 상품 ({selectedItems.length}개)</span>
						<span>₩{getSelectedTotalPrice().toLocaleString()}</span>
					</div>
					<div className="summary-row">
						<span>배송비</span>
						<span>무료</span>
					</div>
					<div className="summary-row total">
						<span>총 금액</span>
						<span>₩{getSelectedTotalPrice().toLocaleString()}</span>
					</div>
					
					<button 
						className="checkout-btn"
						onClick={handleCheckout}
					>
						주문하기
					</button>
				</div>
			</div>
		);
	}

	export default Cart;
